import type {
  ListUsersDirectionOptions,
  ListUsersOrderOptions,
} from '@/modules/chatting/types'

export const listUsersOrderOptions: {
  label: string
  value: ListUsersOrderOptions
}[] = [
  { label: 'Default', value: 'default' },
  { label: 'Recent', value: 'recent' },
]

export const listUsersSortOptions: {
  label: string
  value: ListUsersDirectionOptions
}[] = [
  { label: 'Ascending', value: 'asc' },
  { label: 'Descending', value: 'desc' },
]
